export default __webpack_public_path__ + "static/media/37.355172c7.svg";